<div class="formatted-text" [ngClass]="{ 'formatted-text--aligned-image': alignedImage }">
  <div *ngIf="alignedImage" class="formatted-text__image formatted-text__image--{{ alignment }}">
    <figure>
      <air-focal-image [image]="alignedImage.image"></air-focal-image>
    </figure>
  </div>
  <div class="formatted-text__body">
    <air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
    <div [internalInnerHtml]="content.body" [userEventSource]="userEventSource"></div>
    <div class="formatted-text__cta button__group" *ngIf="hasLinks">
      <a *ngFor="let link of content.links" [airLink]="link" [userEventSource]="userEventSource" class="button {{ getButtonClass() }}">
        <span>{{ link.label }}</span>
        <i class="icon icon-{{ link.icon }}" *ngIf="link.icon"></i>
      </a>
    </div>
  </div>
</div>
